var DEFAULT_MESSAGE = 'Значение вне диапазона';
var EMPTY_DEFAULT_MESSAGE = 'Требуется значение';
var numberInRange = function numberInRange(_a) {
  var from = _a.from,
    to = _a.to,
    _b = _a.includeBoundaries,
    includeBoundaries = _b === void 0 ? true : _b,
    _c = _a.message,
    message = _c === void 0 ? DEFAULT_MESSAGE : _c,
    _d = _a.emptyMessage,
    emptyMessage = _d === void 0 ? EMPTY_DEFAULT_MESSAGE : _d;
  return function (number) {
    if (!number && number !== 0) {
      return emptyMessage;
    }
    if (includeBoundaries) {
      if (number >= from && number <= to) {
        return;
      }
    } else if (number > from && number < to) {
      return;
    }
    return message;
  };
};
export default numberInRange;
export { numberInRange };